module.exports = __webpack_public_path__ + "static/TiemposTextWeb-SemiboldItalic-4291c1c4e0d926080e3e4812b4a6857d.woff";